import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Table,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Chip,
} from "@mui/material";
import GlobalWrapper from "../../../../../components/Wrapper/GlobalWrapper";
import {
  LogButton,
  ViewButton,
} from "../../../../../components/mui/Buttons/Buttons";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch, useSelector } from "react-redux";
import Loader3D from "../../../../../components/Loader/Loader3D";
import { getSessionLogCrm } from "../../../../../redux/features/CRDslice";

const SessionLog = ({ data, rowData, courseEnrollmentId,crm }) => {
  const [open, setOpen] = useState(false);

  const { loading, sessionLogCrm } = useSelector((state) => state.crd);

  const dispatch = useDispatch();

  const headers = [
    "Sl No",
    "Session Date",
    "From Time",
    "To Time",
    "Attendance Type",
    "Subject",
    "Lessons",
    "Remarks",
    "Tutor Name",
  ];
  const rows = [
    {
      id: 1,
      subject: "English",
      fee_per_session: 120,
    },
    {
      id: 2,
      subject: "Physics",
      fee_per_session: 150,
    },
    {
      id: 3,
      subject: "Biology",
      fee_per_session: 140,
    },
  ];

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      color: theme.palette.common.black,
      fontSize: 13,
      border: "1px solid #ccc",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 13,
      border: "1px solid #ccc",
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  useEffect(() => {
    if (open) {
      dispatch(getSessionLogCrm(courseEnrollmentId));
    }
  }, [open]);

  return (
    <GlobalDialog
      title="Session Log"
      open={open}
      setOpen={setOpen}
      fullWidth
      loading={true}
      closeButton={true}
      maxWidth={"lg"}
      popupButton={
        <ViewButton size="small" action={() => setOpen(true)} disabled={!crm}>
          View
        </ViewButton>
      }
      content={
        <>
          {loading ? (
            <Loader3D />
          ) : (
            <GlobalWrapper>
              <Stack
                direction={{
                  xs: "column",
                  sm: "row",
                }}
                spacing={1}
                paddingBottom={3}
              >
                <Box
                  sx={{
                    backgroundImage:
                      "linear-gradient(to right,#251351,#040926)",
                    px: "20px",
                    py: "10px",
                    borderRadius: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "16px",
                  }}
                >
                  Admission No : {rowData.admn_no}
                </Box>
                <Box
                  sx={{
                    backgroundImage:
                      "linear-gradient(to right,#251351,#040926)",
                    px: "20px",
                    py: "10px",
                    borderRadius: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "16px",
                  }}
                >
                  Student Name : {rowData.student_name}
                </Box>
                <Box
                  sx={{
                    backgroundImage:
                      "linear-gradient(to right,#251351,#040926)",
                    px: "20px",
                    py: "10px",
                    borderRadius: "15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "16px",
                  }}
                >
                  Course : {rowData.course_name}
                </Box>
              </Stack>
              <Paper
                sx={{
                  margin: 1,
                  borderRadius: 4,
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #ccc",
                    borderCollapse: "collapse",
                    marginTop: 2,
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {headers.map((header, index) => (
                        <StyledTableCell key={index} align="center">
                          {header}
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sessionLogCrm?.map((row) => (
                      <StyledTableRow key={row.sl_no}>
                        <StyledTableCell align="center">
                          {row.sl_no}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.attendance_date}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.from_time}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.to_time}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.attendance_type_name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.subject_name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.lessons}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.trainer_remarks}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.full_name}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </GlobalWrapper>
          )}
        </>
      }
    />
  );
};

export default SessionLog;
